export default __webpack_public_path__ + "static/automotive-software-eba2a12c65a5a6210be5f897dbc49cac.svg";